import { Button } from "antd";
import React from "react";
interface ButtonSecondaryProps {
  onClick?: () => void;
  title: string;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
  style?: any;
}
const SecondaryButton = ({ ...props }: ButtonSecondaryProps) => {
  return (
    <Button
      {...props}
      title=""
      className={`takaful--secondary-button ${props.className}`}
    >
      {props.loading ? "جار التحميل" : props.title}
    </Button>
  );
};

export default SecondaryButton;
